import DivBottom from '../../../userNotAuth/components/divBottom'
import NavbarNotAuth from '../../../userNotAuth/components/navbarNotAuth'
import NavbarTopAdmin from '../../../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../../../admin/components/navbarBottomAdmin'
import AuthProvider from '../../../Authentication/authProvider'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

function AddRistoSuccess() {
    const navigate = useNavigate()

    useEffect(() => { window.scrollTo(0, 0) }, [])
    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}

        <AuthProvider />

        <div className='container' style={{ marginBottom: '1rem', marginTop: '8rem' }}>
            <h4 style={{ backgroundColor: 'yellow', width: 'fit-content', padding: '10px' }}>RISTORANTE INSERITO CON SUCCESSO!</h4>
            <p className='fs-3 mt-5'>
                Il tuo ristorante è stato inserito.
            </p>
            <p>Potrai modificare il tuo ristorante in qualunque momento andando nel menù <i><mark>account</mark> </i> e cliccando <i><mark>Profilo ristorante</mark></i>.
            </p>
            <hr />

            <div className='mt-5'>
                <button className='btn btn-secondary' onClick={() => { navigate('/profiloRistorante', { replace: true }) }}>⇒ Profilo ristorante
                </button>
            </div>
        </div >
        <DivBottom />
    </>)
}
export default AddRistoSuccess
